import { type Ref, computed } from "vue";
import { useStore } from "vuex";

import { useMutation, useQuery } from "@tanstack/vue-query";

import { ONE_MINUTE_MS } from "@/helpers/constants";
import applicationsService from "@/services/modules/applications";

const APPLICATION_QUERY_KEYS = {
  PHONE_NUMBERS: ["options", "checkout"],
} as const;

export const useBulkToggleOffersSharedMutation = () => {
  const store = useStore();

  type BulkToggleOffersSharedParams = Parameters<
    typeof applicationsService.bulkToggleShowOffers
  >;

  return useMutation({
    mutationFn: (payload: {
      dealId: BulkToggleOffersSharedParams[0];
      data: BulkToggleOffersSharedParams[1];
    }) =>
      applicationsService.bulkToggleShowOffers(payload.dealId, payload.data),
    onSuccess: () => {
      store.dispatch("applications/getOffers");
    },
  });
};

export const useApplicationPhoneNumbersQuery = (appId: Ref<string>) => {
  return useQuery({
    queryKey: [APPLICATION_QUERY_KEYS.PHONE_NUMBERS, appId],
    queryFn: () => applicationsService.getApplicationPhoneNumbers(appId.value),
    staleTime: ONE_MINUTE_MS,
    enabled: computed(() => !!appId.value),
  });
};
